import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Layers } from "lucide-react";

interface IncludedLayersTooltipProps {
  layerNames: string[];
  // Shown above the list. Defaults to a plain "Includes".
  heading?: string;
  className?: string;
  // Set when the icon sits inside a <label>: without it, clicking the icon
  // toggles the label's checkbox.
  preventLabelToggle?: boolean;
}

// The "includes these layers" hover shown next to a product, billable group or
// summary row. Used by the picker tree and the quote summary table, so a styling
// or z-index change lands in one place.
export const IncludedLayersTooltip = (props: IncludedLayersTooltipProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span
        className="flex shrink-0 items-center"
        onClick={
          props.preventLabelToggle ? (e) => e.preventDefault() : undefined
        }
      >
        <Layers
          className={`text-muted-foreground ${props.className ?? "size-4"}`}
        />
      </span>
    </TooltipTrigger>
    {/* z-2000 keeps the tooltip above the Clip step dialogs. */}
    <TooltipContent className="z-2000">
      <p className="mb-1 font-medium">
        {props.heading ?? `Includes ${props.layerNames.length} layers`}
      </p>
      <ul className="flex flex-col gap-0.5">
        {props.layerNames.map((layerName) => (
          <li key={layerName}>{layerName}</li>
        ))}
      </ul>
    </TooltipContent>
  </Tooltip>
);
